// 5-minute time grid.
export const HOURS_QUANTUM = 1 / 12;

export const roundUpToQuantum = (hours: number): number => {
    if (hours <= 0) {
        return 0;
    }
    return Math.ceil(hours / HOURS_QUANTUM) * HOURS_QUANTUM;
};

export const parseHM = (raw: string): number | null => {
    const s = raw.trim();
    if (!s) {
        return null;
    }
    const colon = s.match(/^(\d+):(\d{1,2})$/);
    if (colon) {
        const h = Number(colon[1]);
        const m = Number(colon[2]);
        if (!Number.isFinite(h) || !Number.isFinite(m) || m < 0 || m >= 60) {
            return null;
        }
        return h + m / 60;
    }
    const n = Number.parseFloat(s);
    if (Number.isFinite(n) && n >= 0) {
        return n;
    }
    return null;
};

export const formatHM = (hours: number): string => {
    if (hours === 0) {
        return '0:00';
    }
    const sign = hours < 0 ? '-' : '';
    const magnitude = Math.abs(hours);
    // 0.001-minute epsilon before ceil() so a value already sitting exactly on the grid
    // (e.g. 2.0833... = 2:05) doesn't get bumped to the next quantum by floating-point noise.
    const rawMinutes = magnitude * 60;
    const snappedMinutes = Math.ceil((rawMinutes - 0.001) / 5) * 5;
    const h = Math.floor(snappedMinutes / 60);
    const m = snappedMinutes % 60;
    return `${sign}${h}:${String(m).padStart(2, '0')}`;
};

export const formatHhMm = (hours: number, opts: { alwaysShowMinutes?: boolean } = {}): string => {
    if (hours === 0) {
        return opts.alwaysShowMinutes ? '0h 00m' : '0h';
    }
    const sign = hours < 0 ? '-' : '';
    const magnitude = Math.abs(hours);
    const rawMinutes = magnitude * 60;
    const snappedMinutes = Math.ceil((rawMinutes - 0.001) / 5) * 5;
    const h = Math.floor(snappedMinutes / 60);
    const m = snappedMinutes % 60;
    if (m === 0 && !opts.alwaysShowMinutes) {
        return `${sign}${h}h`;
    }
    if (h === 0) {
        return `${sign}${m}m`;
    }
    return `${sign}${h}h ${String(m).padStart(2, '0')}m`;
};
